import { Component, inject, computed } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from 'src/app/services/profile.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-banner-upgrade',
  standalone: false,
  templateUrl: './banner-upgrade.component.html',
  styleUrl: './banner-upgrade.component.scss'
})
export class BannerUpgradeComponent {
  private router = inject(Router);
  private profileService = inject(ProfileService);

  private roLevel = toSignal(this.profileService.getRoLevel$());
  private profile = toSignal(this.profileService.profileData$);

  isShowByLevel = computed(() => {
    const level = this.roLevel();
    return level !== undefined ? level < 2 : false;
  });

  isShowByJoinDate = computed(() => {
    const profileData = this.profile();
    if (profileData && profileData.join_date) {
      const joinDate = new Date(profileData.join_date).getTime();
      const now = new Date().getTime();
      const diffInHours = (now - joinDate) / (1000 * 60 * 60);
      return diffInHours < 72;
    }
    return false;
  });

  handleUpgrade(): void {
    this.router.navigate(['/subscriptions/upgrade-package']);
  }
}
